import React, { Component } from "react";
import { Link } from "react-router-dom";

import format from "date-fns/format";
import classNames from "classnames";

import styles from "./NewslettersList.css";

class NewslettersList extends Component {
  constructor(props) {
    super(props);
    this.onClickMoreIssues = this.onClickMoreIssues.bind(this);
    this.state = {
      page: 1,
    };
  }

  onClickMoreIssues() {
    const page = this.state.page + 1;
    this.props.onClickMoreIssues(page);
    this.setState({ page });
  }

  render() {
    const {
      subscriptionNewsletters,
      subscriptionId,
      newsletterId,
      className,
    } = this.props;
    if (!subscriptionNewsletters) return null;

    return (
      <div className={className}>
        <ul className={styles.root}>
          {subscriptionNewsletters.results.map((sn, index) => (
            <li key={sn.id} className={styles.listItem}>
              <Link
                to={`/newsletters/${subscriptionId}-${sn.id}.html`}
                className={classNames(
                  styles.item,
                  newsletterId === sn.id || (!newsletterId && index === 0)
                    ? styles.active
                    : {}
                )}
              >
                {format(sn.published_date, "ddd, MMM D")}
              </Link>
            </li>
          ))}
          {subscriptionNewsletters.next && (
            <li
              key="more"
              className={classNames(styles.listItem)}
              onClick={this.onClickMoreIssues}
            >
              <span className={styles.item}>+ More Issues</span>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default NewslettersList;
